module.exports = __webpack_public_path__ + "img/solution4.c4b45b92.png";